import * as React from 'react';
import { SVGProps } from 'react';

const ShieldKeyhole = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" {...props}>
    <path d="M57 127L240 49.4 423 127c5.9 2.5 9.1 7.8 9 12.8c-.4 91.4-38.4 249.3-186.3 320.1c-3.6 1.7-7.8 1.7-11.3 0C86.4 389 48.5 231.2 48 139.7c0-5 3.1-10.2 9-12.8zM441.7 82.8L253.4 2.9C249.2 1 244.7 0 240 0s-9.2 1-13.4 2.9L38.3 82.8C16.3 92.1-.1 113.8 0 140c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C438.8 420.7 479.5 239.2 480 140c.1-26.2-16.3-47.9-38.3-57.2zM296 208c0-30.9-25.1-56-56-56s-56 25.1-56 56c0 22.3 13.1 41.6 32 50.6V328c0 13.3 10.7 24 24 24s24-10.7 24-24V258.6c18.9-9 32-28.3 32-50.6z" />
  </svg>
);

export default ShieldKeyhole;
